/*
 * Purpose: Immutable mission dossier entry types — append-only audit of AI + system actions
 * Last modified: 2026-06-28 | Agent
 * Completeness: 100
 */

export type MissionDossierActor = 'ai' | 'system' | 'human';

export type MissionDossierKind =
  | 'mission_started'
  | 'outcome_edited'
  | 'interpret'
  | 'confirm'
  | 'mode_switch'
  | 'plan'
  | 'director'
  | 'discovery'
  | 'connector_built'
  | 'dry_run'
  | 'automation_consent'
  | 'risk_approval'
  | 'human_action'
  | 'error'
  | 'approve'
  | 'live_run'
  | 'task_receipt'
  | 'map_patch';

export interface MissionDossierEntry {
  /** Monotonic sequence within mission session — immutable once written */
  seq: number;
  id: string;
  missionSessionId: string;
  at: string;
  actor: MissionDossierActor;
  kind: MissionDossierKind;
  /** One-line headline for humans and AI */
  summary: string;
  /** What the AI inferred or decided (when actor is ai) */
  reasoning?: string;
  /** Concrete action taken */
  action?: string;
  payload?: Record<string, unknown>;
  /** Set after successful server append */
  syncedAt?: string;
}

export type MissionDossierFile = {
  missionSessionId: string;
  entries: readonly MissionDossierEntry[];
  /** AI-facing instruction — never mutate entries in prompts */
  readonly dropboxNotice: string;
};

export const MISSION_DOSSIER_DROPBOX_NOTICE = `MISSION DOSSIER (immutable audit file — READ ONLY for AI)
This is an append-only record of everything AutoBlocks and the AI have done on this Mission.
Read for continuity. Do NOT rewrite, delete, or contradict prior entries. New reasoning appends only.`;
